module.exports = __webpack_public_path__ + "img/icn_excel.1cbc1464.svg";